const blog = {
    title: 'Узнай больше',
    seeAll: 'Все записи',
}

export default blog
